import type { BadgeProps } from '@erp/ui/badge';
import type { TaskPriority, TaskStatus } from '@erp/rpc';

export const PRIORITY_DOT_COLORS: Record<TaskPriority, string> = {
  urgent: 'bg-red-500',
  high: 'bg-orange-500',
  medium: 'bg-yellow-500',
  low: 'bg-gray-400',
};

export const STATUS_BADGE_VARIANTS: Record<
  TaskStatus,
  NonNullable<BadgeProps['variant']>
> = {
  pending: 'outline',
  in_progress: 'success',
  completed: 'secondary',
  failed: 'destructive',
  cancelled: 'outline',
  needs_input: 'warning',
};

export function formatStatusLabel(status: TaskStatus) {
  return status.replaceAll('_', ' ');
}
